import { CreateRoleInput } from "./dto/createRoleInput"
import { CreateRoleOutput } from "./dto/createRoleOutput"
import { EntityDto } from "../../dto/entityDto"
import { GetAllRoleOutput } from "./dto/getAllRoleOutput"
import { GetRoleAsyncInput } from "./dto/getRolesAsyncInput"
import GetRoleAsyncOutput from "./dto/getRoleAsyncOutput"
import { GetRoleForEditOutput } from "./dto/getRoleForEditOutput"
import type { PagedResultDto } from "../../dto/pagedResultDto"
import { PagedRoleResultRequestDto } from "./dto/PagedRoleResultRequestDto"
import { UpdateRoleInput } from "./dto/updateRoleInput"
import { UpdateRoleOutput } from "./dto/updateRoleOutput"
import http from "../../httpService"
import { GetAllPermissionsOutput } from "@services/administrator/role/dto/getAllPermissionsOutput"
import { L, LNotification } from "@lib/abpUtility"
import { normalizePermissionList } from "@lib/permissionNormalize"
import { notifySuccess } from "@lib/helper"

class RoleService {
  public async create(
    createRoleInput: CreateRoleInput
  ): Promise<PagedResultDto<CreateRoleOutput>> {
    const result = await http.post(
      "api/services/app/Role/Create",
      createRoleInput
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification(L("SAVE_SUCCESSFULLY"))
    )
    return result.data.result
  }

  public async getRolesAsync(
    getRoleAsyncInput: GetRoleAsyncInput
  ): Promise<GetRoleAsyncOutput> {
    const result = await http.get("api/services/app/Role/GetRolesAsync", {
      params: getRoleAsyncInput,
    })
    return result.data.result
  }

  public async update(
    updateRoleInput: UpdateRoleInput
  ): Promise<UpdateRoleOutput> {
    const result = await http.put(
      "api/services/app/Role/Update",
      updateRoleInput
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification(L("SAVE_SUCCESSFULLY"))
    )
    return result.data.result as UpdateRoleOutput
  }

  public async delete(entityDto: EntityDto) {
    const result = await http.delete("api/services/app/Role/Delete", {
      params: entityDto,
    })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification(L("SAVE_SUCCESSFULLY"))
    )
    return result.data
  }

  public async getAllPermissions(): Promise<GetAllPermissionsOutput[]> {
    const result = await http.get("api/services/app/Role/GetAllPermissions")
    return normalizePermissionList(
      result.data.result.items || []
    ) as GetAllPermissionsOutput[]
  }

  public async getRoleForEdit(id): Promise<GetRoleForEditOutput> {
    const result = await http.get("api/services/app/Role/GetRoleForEdit", {
      params: { id },
    })
    return result.data.result
  }

  public async get(entityDto: EntityDto) {
    const result = await http.get("api/services/app/Role/Get", {
      params: entityDto,
    })
    return result.data
  }

  public async getAll(
    pagedFilterAndSortedRequest: PagedRoleResultRequestDto
  ): Promise<PagedResultDto<GetAllRoleOutput>> {
    const result = await http.get("api/services/app/Role/GetAll", {
      params: pagedFilterAndSortedRequest,
    })
    return result.data.result
  }
}

export default new RoleService()
